import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";

// actions
import { getValueColor, getGraphSource, getSmileySource } from "../../../../store/helpers/uiHelper";

import { submitReportCode } from "../../../../store/actions/reports.action";

//icons
import benchmarkPurchased from "../../../../assets/images/icons/tl_benchmark_purchased.svg";
import benchmarkNotPurchased from "../../../../assets/images/icons/tl_benchmark_grey_not_purchased.svg";
import t360Purchased from "../../../../assets/images/icons/tl_360_icon_purchased.svg";
import t360NotPurchased from "../../../../assets/images/icons/tl_360_icon_not_purchased.svg";
import stressGrey from "../../../../assets/images/other/stress_grey.svg";
import faceGrey from "../../../../assets/images/icons/face_grey.svg";

// scss
import "./ReportScore.scss";

const T360 = "t360";
const TEAM_360 = "team-360";
const FULL_REPORT = "full-report";
const BENCHMARK = "bm";
const STRESS_INDEX = "si";
const MORALE_INDEX = "mi";
const CONSULTING = "co";
const COHESION_INDEX = "ci";

class ReportScore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: "",
    };
  }

  goToRoute = (route) => {
    this.props.history.push(route);
  };

  selectTeam360 = () => {
    const { team360Id, updateFormFieldValue } = this.props;
    if (team360Id) {
      updateFormFieldValue("allReports", team360Id);
    }
    return;
  };

  renderPaymentButton(report) {
    return (
      <div className="upgrade-btn">
        <Link
          to={`/product/${report}`}
          onClick={(e) => e.stopPropagation()}
          className="sub-btn"
        >
          <span>Purchase</span>
        </Link>
      </div>
    );
  }

  renderConsulting() {
    return (
      <div className="report__content">
        <div className="consulting-upgrade-btn ">
          <div className="consulting-upgrade-btn__icons">
            <i className="fa fa-pie-chart" />
            <i className="fa fa-line-chart" />
            <i className="fa fa-users" />
            <i className="fa fa-shield" />
            <i className="fa fa-handshake" />
            <i className="fa fa-graduation-cap" />
            <i className="fa fa-flash" />
            <i className="fa fa-gavel" />
          </div>
          <div className="consulting-upgrade-btn__description">
            <span>Book a consulting session with a TeamLytica Expert.</span>
          </div>
          <a target="__blank" href="https://calendly.com/teamlytica/consulting-hour">
            <span>Purchase</span>
          </a>
        </div>
      </div>
    );
  }

  renderScore() {
    const { average } = this.props;

    return (
      <div className="report__content">
        <div className="info-container">
          <div className="blue">
            <span>TL</span>
          </div>
          <div className="details">
            <span className="index">ci</span>
          </div>
        </div>
        {average && (
          <div className={`__details ${getValueColor(average, false)}`}>
            <span>{average}</span>
          </div>
        )}
      </div>
    );
  }

  renderImage() {
    const {
      average,
      averageType,
      isFullReport,
      isTeam360,
      hasBenchmarking,
      team360Id,
    } = this.props;
    switch (averageType) {
      case STRESS_INDEX:
        return average ? (
          <div className="report__content" style={{ backgroundColor: "#fff" }}>
            <img
              src={getGraphSource(average)}
              alt="Stress Index"
              className="report__content_image"
            />
          </div>
        ) : (
          <div
            className="report__content"
            style={{
              backgroundImage: `url(${stressGrey})`,
              backgroundSize: `80%`,
              backgroundColor: "#fff",
            }}
          >
            {!isFullReport && this.renderPaymentButton(FULL_REPORT)}
          </div>
        );
      case MORALE_INDEX:
        return average ? (
          <div className="report__content">
            <img
              src={getSmileySource(average)}
              alt="Morale Index"
              className="report__content_image"
            />
          </div>
        ) : (
          <div
            className="report__content"
            style={{
              backgroundImage: `url(${faceGrey})`,
            }}
          >
            {!isFullReport && this.renderPaymentButton(FULL_REPORT)}
          </div>
        );

      case BENCHMARK:
        return (
          <div
            className={`report__content`}
          >
            <div className="report__content-title">
              <img
                src={hasBenchmarking ? benchmarkPurchased : benchmarkNotPurchased}
                className="report__content_image"
                alt="Benchmark Icon"
              />
              {this.renderPaymentButton(FULL_REPORT)}
            </div>
          </div>
        );
      case T360:
        return (
          <div
            className="report__content"
          >
            <div className="report__content-title">
            <img
                src={isTeam360 || team360Id ? t360Purchased : t360NotPurchased}
                className="report__content_image"
                alt="Benchmark Icon"
              />
              {this.renderPaymentButton(TEAM_360)}
            </div>
          </div>
        );
      default:
        return null;
    }
  }

  getReportProperties() {
    const { averageType, hasBenchmarking, isTeam360, isFullReport, team360Id } = this.props;

    switch (averageType) {
      case COHESION_INDEX:
        return {
          title: "Cohesion Index",
          route: "/reports/cohesion",
          icon: "fa fa-users",
          text: "View your company's Cohesion Index",
          content: this.renderScore(),
          disabled: false,
        };
      case STRESS_INDEX:
        return {
          title: "Stress Indicator",
          route: "/reports/stress",
          icon: "fa fa-dashboard",
          text: "View your company's Stress Index",
          content: this.renderImage(),
          disabled: !isFullReport,
        };
      case MORALE_INDEX:
        return {
          title: "Morale Indicator",
          route: "/reports/morale",
          icon: "fa fa-smile-o",
          text: "View your company's Morale Index",
          content: this.renderImage(),
          disabled: !isFullReport,
        };
      case BENCHMARK:
        return {
          title: "Benchmarking",
          route: "/reports/compare",
          icon: "fa fa-line-chart",
          text: "Purchase Benchmark Reports",
          content: this.renderImage(),
          disabled: !hasBenchmarking,
        };
      case T360:
        return {
          title: "Team 360",
          route: "/reports/your-360-reports",
          icon: "fa fa-dot-circle-o",
          text: "Purchase Team 360 reports",
          content: this.renderImage(),
          disabled: isTeam360 && team360Id,
        };
      case CONSULTING:
        return {
          title: "Consulting",
          route: "/",
          icon: "fa fa-bolt",
          text: "",
          content: this.renderConsulting(),
          disabled: false,
        };
      default:
        return {};
    }
  }

  render() {
    const { averageType, team360Id } = this.props;

    const content = this.getReportProperties().content;
    const disabled = this.getReportProperties().disabled;
    const icon = this.getReportProperties().icon;
    const route = this.getReportProperties().route;
    const text = this.getReportProperties().text;
    const title = this.getReportProperties().title;

    return (
      <div
        className="flex-score-container"
        onClick={
          averageType !== "co" &&
          !disabled &&
          (team360Id && averageType === "t360")
            ? this.selectTeam360
            : () => this.goToRoute(route)
        }
      >
        <div className={`report `}>
          <i className={`${icon}`} />
          <span className="report__title">{title}</span>
        </div>

        {content}

        <div className={`tile-link ${disabled && `grey`}`}>
          <span>{text}</span>
          {averageType !== "co" && <i className="fa fa-chevron-right" />}
        </div>
      </div>
    );
  }
}

ReportScore.propTypes = {
  average: PropTypes.number,
  averageType: PropTypes.string,
  isCurrentReport: PropTypes.bool,
  isFullReport: PropTypes.bool,
  isTeam360: PropTypes.bool,
  hasBenchmarking: PropTypes.bool,
  history: PropTypes.object,
  userPlan: PropTypes.string,
  scoreType: PropTypes.string,
  submitReportCode: PropTypes.func,
  assessment_id: PropTypes.string,
  report: PropTypes.object,
  team360Id: PropTypes.number,
  updateFormFieldValue: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    hasBenchmarking:
      state.general && state.general.content && state.general.content.has_benchmarking,
    isTeam360:
      state.reports && state.reports.reportStatus && state.reports.reportStatus.is_team_360,
    isFullReport:
      state.reports && state.reports.reportStatus && state.reports.reportStatus.is_full_report,
    isCurrentReport:
      state.reports && state.reports.reportStatus && state.reports.reportStatus.is_current,
    team360Id:
      state.reports && state.reports.reportStatus && state.reports.reportStatus.team_360_id,
  };
};

export default connect(mapStateToProps, { submitReportCode })(withRouter(ReportScore));
